import { Flow_0_0_2 } from '@flexus/core';

export const SIL_95: Flow_0_0_2 = {
	id: '95',
	name: 'claim_moved_to_assessor',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: 'Review'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
